import {Component, OnInit, ViewChild} from '@angular/core';
import {HumanInteractionService} from '../../../services/human-interaction.service';
import {BehaviorSubject} from 'rxjs';
import {TabsetComponent} from 'ngx-bootstrap/tabs';
import {PaginationInstance} from 'ngx-pagination';
import {WebClientConfigurationService} from '../../../services/configuration/web-client-configuration.service';
import {StateLifeCycle} from '../../../Models/enum/stateLifeCycle';
import {FormBuilder, FormGroup} from '@angular/forms';
import {AdminService} from '../../../services/admin.service';

@Component({
  selector: 'app-business-process-suspended-list',
  templateUrl: './business-process-suspended-list.component.html',
  styleUrls: ['./business-process-suspended-list.component.css']
})
export class BusinessProcessSuspendedListComponent implements OnInit {

  @ViewChild('tabSuspendedList', { static: false }) tabSuspendedList: TabsetComponent;
  filterForm: FormGroup;

  config: PaginationInstance;
  pageConfig;
  queueConfig;
  customQueueConfig;
  customQueueList;
  columns$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  customColumns$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  errorMessageCommonQueue = '';
  errorMessageCustomQueue = '';

  queueFilter: any;
  customQueueFilter: any;
  hasQueueRight = false;
  hasCustomQueueRight = false;
  isOnInit = true;

  constructor(private formBuilder: FormBuilder, private humanInteractionService: HumanInteractionService,
              private webClientConfig: WebClientConfigurationService, private adminSevice: AdminService) { }

  ngOnInit() {
    this.checkRights();
    this.createForm();
    this.getPageConfig();
    this.getQueue();
    this.getCustomQueue();
    this.queueFilter = this.setQueueFilter();
  }

  checkRights() {
    this.adminSevice.checkItemsRight(25)
      .subscribe(s => { this.hasQueueRight = s; this.isOnInit = false; }, error1 => this.errorMessageCommonQueue = error1);
    this.adminSevice.checkItemsRight(29)
      .subscribe(s => this.hasCustomQueueRight = s, error1 => this.errorMessageCustomQueue = error1);
  }

  setQueueFilter(queueType = 'common'): any {
    const filter = this.filterForm.getRawValue();
    if (queueType == 'custom') {
      filter.customInteractionQueueConfigId = this.customQueueList.map(m => m.id);
    }
    filter.columns = [];
    filter.columnsComparisonType = 1;
    filter.stateLifeCycles = [StateLifeCycle.suspended];

    return filter;
  }

  createForm() {
    this.filterForm = this.formBuilder.group({
      businessProcessId: null,
      columns: null,
      columnsComparisonType: null,
      customInteractionQueueConfigId: null,
      finalDate: null,
      initialDate: null,
      orderByColumnId: null,
      orderByStateModifyDate: false,
      orderDirection: 1,
      pageIndex: 0,
      pageSize: 0,
      stateId: null,
      stateLifeCycles: null,
      userLogon: null
    });
  }

  getQueue() {
    this.errorMessageCommonQueue = '';
    this.humanInteractionService.getInteractionQueue().subscribe( queue => {
        this.queueConfig = queue;
        this.columns$.next(queue.columns);
      }, error1 => {
        this.errorMessageCommonQueue = error1;
        console.log(error1);
      });
  }

  getCustomQueue() {
    this.errorMessageCustomQueue = '';
    this.humanInteractionService.getCustomInteractionQueueConfig().subscribe(custom => {
      this.customQueueList = custom;
      this.customQueueConfig = custom[0];
      this.customQueueConfig.fieldColumns = [
        { field: 'BusinessProcessInstanceId', name: 'Id' },
        { field: 'BusinessProcessName', name: 'Processo de Negócio' },
        { field: 'CustomInteractionQueueName', name: 'Fila Nomeada' },
        { field: 'StateDisplayName', name: 'Estado' },
        { field: 'CreationDate', name: 'Data de Criação' },
        { field: 'StateModifyDate', name: 'Data de Modificação' },
        { field: 'SLA', name: 'Tempo em Fila' }
      ];
      this.customColumns$.next(custom);
      this.customQueueFilter = this.setQueueFilter('custom');
    }, error1 => {
      this.errorMessageCustomQueue = error1;
    });
  }

  getPageConfig() {
    this.errorMessageCommonQueue = '';
    this.errorMessageCustomQueue = '';
    this.webClientConfig.getPageConfig()
      .subscribe(pageConfig => {
          this.pageConfig = pageConfig;
        },
        error1 => {
          this.errorMessageCommonQueue = error1;
          this.errorMessageCustomQueue = error1;
        });
  }

  search(event) {
    event.stateLifeCycles = [ StateLifeCycle.suspended ];
    this.queueFilter = event;
  }

  searchCustom(event) {
    event.stateLifeCycles = [ StateLifeCycle.suspended ];
    this.customQueueFilter = event;
  }

}
